import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

// antd
import { Col, Row, Typography, theme, Divider } from 'antd'

// slices
import { projectsState } from '../../projects/projects.slice'
import { supportState, getSupportSubTaskList } from './support.slice'

// styles
import styles from '../tasks.module.css'

// helpers
import { formatTitle } from '../../../helpers/formatTitle'
import StatusSelector from '../components/statusSelector'
import AssigneeSelectPopover from '../components/assigneeSelector'

const SupportSubTaskSection = ({ assigneeList }) => {
    const { Text, Title } = Typography

    const { useToken } = theme

    const { token } = useToken()

    const dispatch = useDispatch()

    const { currentProjectData } = useSelector(projectsState)
    const { selectedTask, subTasksList } = useSelector(supportState)

    const [swimLanesOption, setSwimLanesOption] = useState([])

    // GET SUB TASKS
    async function subTaskListGet() {
        if (selectedTask?._id) {
            await dispatch(
                getSupportSubTaskList({
                    skip: 0,
                    limit: 10,
                    parentId: selectedTask?._id,
                })
            )
        }
    }

    // GET SWIMLANES
    useEffect(() => {
        if (currentProjectData?.swimlanes?.length > 0) {
            const options = currentProjectData?.swimlanes.map((data) => {
                return {
                    label: data?.name,
                    value: data?._id,
                }
            })
            setSwimLanesOption(options)
        }
    }, [currentProjectData])

    // FETCH SUB TASKS WHEN SELECTED TASK CHANGES
    useEffect(() => {
        if (selectedTask?._id) {
            subTaskListGet()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTask?._id])

    return (
        <>
            <div>
                {subTasksList?.length > 0 && (
                    <Row
                        justify={'space-between'}
                        align={'middle'}
                        style={{
                            padding: '0px 20px',
                        }}
                    >
                        <Title
                            level={4}
                            style={{
                                fontSize: '17px',
                            }}
                        >
                            Sub tasks
                        </Title>
                        <Divider
                            style={{
                                margin: '13px 0px 13px 0px',
                            }}
                        />
                    </Row>
                )}
                {subTasksList?.length > 0 && (
                    <div>
                        {subTasksList.map((st, index) => (
                            <div
                                key={st?._id || index}
                                style={{
                                    padding: '0px 15px',
                                }}
                            >
                                <Row
                                    align={'middle'}
                                    justify={'space-between'}
                                    className={styles.viewSubTaskList}
                                    style={{
                                        flexFlow: 'row nowrap',
                                    }}
                                >
                                    <Col>
                                        <Row
                                            gutter={12}
                                            align={'middle'}
                                            style={{
                                                flexFlow: 'row nowrap',
                                            }}
                                        >
                                            <Col>
                                                <Text
                                                    style={{
                                                        color: token
                                                            .colorPalette
                                                            .baseColor.tertiary,
                                                        cursor: 'default',
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    {st?.taskKey}
                                                </Text>
                                            </Col>
                                            <Col>
                                                <div
                                                    style={{
                                                        fontSize: 14,
                                                        fontWeight: 500,
                                                        wordBreak: 'break-word',
                                                    }}
                                                >
                                                    {formatTitle(st?.title, 20)}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                    <Col>
                                        <Row
                                            gutter={12}
                                            align={'middle'}
                                            style={{
                                                flexFlow: 'row nowrap',
                                            }}
                                        >
                                            <Col>
                                                <StatusSelector
                                                    statusType={swimLanesOption}
                                                    name="status"
                                                    updateDetails={() => {
                                                        // No-op - read-only
                                                    }}
                                                    value={{
                                                        label: swimLanesOption?.find(
                                                            (item) =>
                                                                item?.value ===
                                                                st?.status
                                                        )?.label,
                                                        value: st?.status,
                                                    }}
                                                    disabled={true}
                                                />
                                            </Col>
                                            <Col>
                                                <AssigneeSelectPopover
                                                    searchable
                                                    assigneeList={assigneeList}
                                                    selectedAssignee={
                                                        st?.assigneeId?.[0]
                                                    }
                                                    onChange={() => {
                                                        // No-op - read-only
                                                    }}
                                                    disabled={true}
                                                />
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                                <Divider
                                    style={{
                                        margin: '10px 0px 10px 0px',
                                    }}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </>
    )
}

export default SupportSubTaskSection
